import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";


export const listClerk = (id, name, sex, grade, status, isDisabled, isRecommend, isTop,
                          isHide, isVerified, requireVerify, randomOrderSwitch, isFixGrade,pageNo,pageSize) => {
  let data = new URLSearchParams()
  appendIfNotEmpty(data,'id',id)
  appendIfNotEmpty(data,'name',name)
  appendIfNotEmpty(data,'sex',sex)
  appendIfNotEmpty(data,'grade',grade)
  appendIfNotEmpty(data,'status',status)
  appendIfNotEmpty(data,'isDisabled',isDisabled)
  appendIfNotEmpty(data,'isRecommend',isRecommend)
  appendIfNotEmpty(data,'isTop',isTop)
  appendIfNotEmpty(data,'isHide',isHide)
  appendIfNotEmpty(data,'isVerified',isVerified)
  appendIfNotEmpty(data,'requireVerify',requireVerify)
  appendIfNotEmpty(data,'randomOrderSwitch',randomOrderSwitch)
  appendIfNotEmpty(data,'isFixGrade',isFixGrade)
  data.append('pageNo',pageNo)
  data.append('pageSize',pageSize)
  return axios.request({
    url: '/s/l/clerk/list',
    data,
    method: 'post'
  })
}


